var map = {
	"./flake.png": 73,
	"./flake@2x.png": 74
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 192;



//////////////////
// WEBPACK FOOTER
// ./themes/mf/img ^\.\/flake.*\.png$
// module id = 192
// module chunks = 3